import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles'
import 'react-credit-cards/es/styles-compiled.css';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import SuccessPaymentEnhancedTable from './SuccessPaymentEnhancedTable';
import SuccessCreditMemoTable from './SuccessCreditMemoTable';
import NumberFormat from 'react-number-format';
import ReactDOMServer from "react-dom/server";
import jsPDF from 'jspdf';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import OpenModal from './OpenModal';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',     
    transform             : 'translate(-50%, -50%)',
    padding               : '0',
    border                : 'none',
    borderRadius          : '0',
    boxShadow             : '0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.6)',
    overlfow              : 'hidden'
  }
};

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  table: {
    margin: theme.spacing.unit / 2,
    [theme.breakpoints.up('sm')]: {
      paddingTop: 24,
    }
  },
  typo: {
    padding: theme.spacing.unit * 3
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonLink: {
    color: 'inherit',
    textDecoration: 'none'
  },
  header: {
    paddingLeft: '24px',
    paddingRight: '24px', 
    fontSize: '26px',
    fontFamily: 'Averia Serif Libre, cursive',
    fontWeight: '100',
    color: 'red',
     backgroundColor: '#fa451c'
  }
});

class ThankYou extends Component {

  constructor(props) {
    super(props);   
    this.state = {
      pdf: true,
      modalIsOpen: false
  }
   this.openModal = this.openModal.bind(this);      
   this.closeModal = this.closeModal.bind(this);
}

openModal = (modalMessage) =>{     
  this.setState(
      {
      modalIsOpen: true,
      modalMessage:modalMessage
  });        
}

closeModal = () => {
  this.setState({modalIsOpen: false});
}

close_modal() {
  this.closeModal()
}

componentDidMount(){
  this.openModal('exportPDF');
}

pdfGenerate(){
  if(this.state.modalIsOpen === true){
    this.closeModal()
  }
  let customerDetails = JSON.parse(localStorage.getItem('customer'));
  let invoiceRows = this.invoiceDetails();
  let invoiceAmount  = JSON.parse(localStorage.getItem('paidData'));
  let creditRows = this.creditDetails();
  let docDefinition = {
    header: function(page) { 
      if (page == 1)
      return{margin: [0, 0, 0, 60], columns: [
      {
        margin: [220, 7, 0, 60],
      image: "data:image/png;base64,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",
      width: 150, 
    },
      ]}
      else 
      return{}},
    content: [
      {margin: [0, 5, 0, 2],text:'Payment Portal', style: 'header'},
      { text: 'Invoice Details', style: 'InvoiceDetails', margin: [0, 20, 10 , 10]},
      {
        table: {
          widths: [ '*', 200],
          body: [
            [{ text: 'Name: '+customerDetails.name, style: 'customer', margin: [0, 3], border:[false,false,false,false]}, { text: 'Transaction Date: '+invoiceAmount['transactionDate'], style: 'transaction', margin: [0, 3], border:[false,false,false,false]}],
            [{ text: 'Address: '+customerDetails.address1+' '+customerDetails.address2, style: 'customer', margin: [0, 3], border:[false,false,false,false]}, { text: 'Transaction Id: '+invoiceAmount['transactionId'], style: 'transaction', margin: [0, 3], border:[false,false,false,false]}],
            [{ text: 'City: '+customerDetails.city, style: 'customer', margin: [0, 3], border:[false,false,false,false]}, { text:((customerDetails.currencyCode === 'CAD')?'Net Amount Paid: CAD ':'Net Amount Paid: $ ')+parseFloat(invoiceAmount['paymentAmount']).toFixed(2), style: 'transaction', margin: [0, 3], border:[false,false,false,false]}],
            [{ text: 'Country: '+customerDetails.country, style: 'customer', margin: [0, 3], border:[false,false,false,false]}, { text: `Mode of Payment: ${invoiceAmount['paymentMethod']} ${invoiceAmount['paymentMethod'] === 'ach' ? invoiceAmount['creditCardNumber'].replace(/\d(?=\d{4})/g, "*") : invoiceAmount['creditCardNumber'] }`, style: 'transaction', margin: [0, 3], border:[false,false,false,false]}],
            [{ text: 'Phone: '+customerDetails.phone, style: 'customer', margin: [0, 3], border:[false,false,false,false]}, { text: '', style: 'customer', margin: [0, 3], border:[false,false,false,false]}]
          ]
        }
      },
      { text: 'Invoice Amount', style: 'InvoiceDetails', margin: [0, 20, 10 , 10]},
      
      {
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: [ '*', 75, 150,150],
        body: invoiceRows
      },
      layout: {
        hLineColor: 'grey',
      },
    },
    {
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: [ '*', '*',  '200'],
        body: [[{text:'',margin: [0, 10, 0, 0],border:[false,false,false,false]},{text:'',margin: [0, 10, 0, 0],border:[false,false,false,false]},{text:((customerDetails.currencyCode === 'CAD')?'Total Invoice Amount: CAD ':'Total Invoice Amount: $ ')+parseFloat(invoiceAmount['totalInvoiceAmount']).toFixed(2) ,style: 'invoiceTotal',  margin: [0, 10, 0, 0], border:[false,false,false,false]}]]
      },
      layout: {
        hLineColor: 'grey',
      },
    },
    
   { text: 'Credit Amount', style: 'InvoiceDetails', margin: [0, 20, 10, 10]},

    {
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        backgroundColor: 'red',
        widths: [ '*', 150, 150],
        body: creditRows
      },
      layout: {
        hLineColor: 'grey',
      },
    },
    {
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: [ '*', '*',  '200'],
        body: [[{text:'' ,style: 'creditMemo', margin: [0, 10, 0, 0], border:[false,false,false,false]},{text:'' ,style: 'invoiceTotal',  margin: [0, 10, 0, 0], border:[false,false,false,false]}, {text: invoiceAmount['creditmemoDetails'].length > 0 ? ((customerDetails.currencyCode === 'CAD')?'Total Credit Memo: CAD ':'Total Credit Memo: $ ')+parseFloat(invoiceAmount['totalCreditMemoAmount']).toFixed(2) : '',style: 'invoiceTotal',  margin: [0, 10, 0, 0], border:[false,false,false,false]}]]
      },
      layout: {
        hLineColor: 'grey',
      },
    },
    {
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        headerRows: 1,
        widths: [ '*', '*',  '200'],
        body: [[{text:'' ,style: 'invoiceTotal',  margin: [0, 10, 0, 0], border:[false,false,false,false]}, {text: '',style: 'creditMemoAmount',  margin: [0, 10, 0, 0], border:[false,false,false,false]},{text:((customerDetails.currencyCode === 'CAD')?'Net Amount Paid: CAD ':'Net Amount Paid: $ ')+parseFloat(invoiceAmount['paymentAmount']).toFixed(2) ,style: 'netTotal', margin: [0, 10, 0, 0], border:[false,false,false,false]}]]
      },
      layout: {
        hLineColor: 'grey',
      },
    },
    ],
 
    styles: {
      header: {
        
        width: '100%',
        bold: true,
        color: 'red',
        padding: '5px',
        fontSize: '18',
        fontFamily: 'Averia Serif Libre',
        fontWeight: '100',
        
      },
      InvoiceDetails: {
        fontSize: '15',
        bold: true,
      },
      customer: {
        fontSize: '10',
      },
      transaction: {
        fontSize: '10',
        alignment: 'right'
      },
      tableHeader: {
        bold: true,
        fontSize: '12',
        alignment: 'center',
        border: 'none',
        color: 'grey'
      },
      tableBody: {
        alignment: 'center',
        fontSize: '10'        
      },
     creditMemo: {
      alignment: 'left',
      fontSize: '10',
      bold: true,
     },
     creditMemoAmount: {
      alignment: 'right',
      fontSize: '10',
      bold: true,
     },
     invoiceTotal: {
      alignment: 'right',
      fontSize: '12',
      bold: true, 
      fontWeight: '400'
     },
     netTotal: {
      alignment: 'right',
      fontSize: '12',
      color: '#fa451c',
      bold: true, 
      fontWeight: '400'
     }
    }
  };

  
  pdfMake.createPdf(docDefinition).download('Invoice.pdf');
}
 
invoiceDetails(){
  let invoiceDetails  = JSON.parse(localStorage.getItem('paidData'));
  let customerDetails = JSON.parse(localStorage.getItem('customer'));
  invoiceDetails = invoiceDetails['invoiceDetails'];
  let invoice = [];
  invoice.push([{text:'Invoice Number' ,style: 'tableHeader', margin: [0, 5],border:[false,false,false,true]},{text:'Installment' ,style: 'tableHeader', margin: [0, 5],border:[false,false,false,true]},{text:'Invoice Date' ,style: 'tableHeader', margin: [0, 5],border:[false,false,false,true]},{text:'Paid Amount' ,style: 'tableHeader',  margin: [0, 5],border:[false,false,false,true]}])
    {invoiceDetails.map(row => {
      invoice.push([{text:row.invoiceNumber ,style: 'tableBody',border:[false,false,false,true]},{text:row.installments,style: 'tableBody',border:[false,false,false,true]},{text:row.invoiceDate ,style: 'tableBody',border:[false,false,false,true]},{text:((customerDetails.currencyCode === 'CAD')?'CAD ':'$ ')+(row.paymentAmount) ,style: 'tableBody',border:[false,false,false,true]}])
    })}
  return invoice;
}
creditDetails(){
  let creditDetails  = JSON.parse(localStorage.getItem('paidData'));
  creditDetails = creditDetails['creditmemoDetails'];
  let creditAmount  = JSON.parse(localStorage.getItem('paidData'));
  let customerDetails = JSON.parse(localStorage.getItem('customer'));
  let credit = [];
  if(creditDetails.length > 0){
  credit.push([{text:'Transaction Number' ,style: 'tableHeader', margin: [0, 5],border:[false,false,false,true]},{text:'Date' ,style: 'tableHeader', margin: [0, 5],border:[false,false,false,true]},{text:'Amount' ,style: 'tableHeader',  margin: [0, 5],border:[false,false,false,true]}])
    {creditDetails.map(row => {
      credit.push([{text:row.invoiceNumber ,style: 'tableBody',border:[false,false,false,true]},{text:row.invoiceDate ,style: 'tableBody',border:[false,false,false,true]},{text:((customerDetails.currencyCode === 'CAD')?'CAD ':'$ ')+(row.paymentAmount) ,style: 'tableBody',border:[false,false,false,true]}])
    })}
    
  return credit;}
  else{
    credit.push([{text:'Transaction Number' ,style: 'tableHeader', margin: [0, 5],border:[false,false,false,true]},{text:'Date' ,style: 'tableHeader', margin: [0, 5],border:[false,false,false,true]},{text:'Amount' ,style: 'tableHeader',  margin: [0, 5],border:[false,false,false,true]}])
      credit.push([{text:'No Credit Memo Selected' ,style: 'tableBody',border:[false,false,false,true]},{text:'' ,style: 'tableBody',border:[false,false,false,true]},{text: '' ,style: 'tableBody',border:[false,false,false,true]}])
    
  return credit;
  }
}



  render() {
    const { classes } = this.props;
    const paidData = JSON.parse(localStorage.getItem('paidData'));
    const customer = JSON.parse(localStorage.getItem('customer'));
    return (
        <div id="invoice" className={classes.root}>
            <div className={classes.table}>
             {this.state.pdf ?
                  <Button style={{float: 'right', fontWeight: 'bold'}} onClick={()=>this.pdfGenerate()}  variant="contained" color="primary">Export to Pdf</Button> : ''} 
              <Paper className={classes.typo}>
                <Typography variant="subheading" component="h3">
                <span style={{color:'rgb(13, 179, 13)'}}>
                  Thanks! Your payment is processed.</span>
                </Typography>
                 <Typography variant="body2" component="h3">
                 <span style={{color:'rgb(13, 179, 13)'}}>
                  Payment is completed for the  following Invoices/Credit Memo</span>
                </Typography>
                <Typography variant="body2" component="h3">
                 <span style={{color:'rgb(250, 69, 28)'}}>
                 Please wait for 15 minutes to reconcile your payment and reflect the same in the portal. Meanwhile, if you wish you can make payment for other invoices.</span>
                </Typography>
                <Typography variant="body2" component="h3">
                            <NumberFormat value={paidData['paymentAmount']}
                            fixedDecimalScale = {true} decimalScale={2}
                            displayType={'text'} thousandSeparator={true} prefix={(customer.currencyCode === 'CAD')  ? 'Total Amount Paid: CAD ' : 'Total Amount Paid: $'}/>                                                                                
                            </Typography>
              </Paper>
              <SuccessPaymentEnhancedTable key={paidData['entryNo']} data={paidData}/>
              <SuccessCreditMemoTable key={paidData['entryNo']} data={paidData}/>
            </div>           
            {<Button component={Link} to={customer.token && customer.code ? `/authenticate/${customer.token}/${customer.code}` : '/'} variant="contained" color="primary" >
            Go Back
        </Button>}
        <OpenModal 
                customStyles={customStyles} modalIsOpen={this.state.modalIsOpen}
                exportPdf={()=>this.pdfGenerate()}
                closeModal={this.closeModal} getParent={this.getParent}
                closeOnClick={this.close_modal.bind(this)} 
                modalMessage={this.state.modalMessage}>
                </OpenModal>
        </div>
        
    );
  }
}

ThankYou.propTypes = {
  classes: PropTypes.object.isRequired
};

export default (withStyles(styles)(ThankYou));


// WEBPACK FOOTER //
// ./src/ThankYou.js